import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import app from 'flarum/forum/app';
import getTags from '../helpers/getTags';
import Link from 'flarum/common/components/Link';

export default class PopularTags extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    const showedTags = app.forum.attribute('bj-community-bje-tags-widget.numberOfTags') || 5;
    const url = app.forum.attribute('baseUrl') + '/api/tags';
    getTags(url).then((res) => {
      this.popularTags = app.store.all('tags');
      this.childTags = res.filter((tag) => tag.attributes.isChild);
      this.loading = false;
      m.redraw();
    });
  }

  className() {
    return 'bje-tags-widget';
  }

  content() {
    return (
      <ul className={`TagTiles ${window.location.pathname === '/' ? '' : 'd-none'}`}>
        {app.store
            .all('tags')
            .filter((singleMainTag) => !singleMainTag.data.attributes.isChild)
            .sort((a, b) => a.data.attributes.position - b.data.attributes.position) // Sortieren nach Position
            .map((tag) => {
            const baseUrl = app.forum.attribute('baseUrl');
            const description = tag.data.attributes.description;
            const filteredChildTags = !this.loading
              ? this.childTags.filter((singleSubTag) => singleSubTag.relationships.parent.data.id === tag.data.id)
              : [];
            return (
              <>
                <li class={`TagTile text-contrast--unchanged tag-count-${filteredChildTags.length}`} id={'tag-name-' + tag.data.attributes.slug}>
                  <Link className="TagTile-info" href={baseUrl + '/t/' + tag.data.attributes.slug}>
                    <h3 class={`TagTile-name ${description === '' && filteredChildTags.length === 0 ? 'mb-0' : ''}`}>{tag.data.attributes.name}</h3>
                    {description !== '' && <p class="TagTile-description">{description}</p>}

                    {filteredChildTags.length > 0 && (
                      <div class="TagTile-children">
                        {filteredChildTags.map((subTag) => (
                          <Link href={baseUrl + '/t/' + subTag.attributes.slug}>{subTag.attributes.name}</Link>
                        ))}
                      </div>
                    )}
                  </Link>
                </li>
              </>
            );
          })}
      </ul>
    );
  }
}
